import Lady from '../images/lady1.png';

export default function Benefits(){
    return(
        <div className="row benefits">
            <div className="col-sm-6 benefits-column1" style={{borderBottom: "1px solid lightgrey"}}>
                 <h2 className="text-center text-white bg-primary p-3" style={{fontWeight:"900"}}>Why Choose 3 Keys Logistics?</h2><br />
                 <p>More than a supplier, we work as a true partner and accompany you with recommendations, based on your mobility data, so that you can reduce your costs,</p>
                 <br />
                <div className="benefits-row">
                    <div></div>
                    <div>
                        <h3>Right Time Delivery</h3>
                        <p>We meet up with deadlines and tight schedules of our clients. You can always trust us.</p>
                    </div>
                </div>

                <div className="benefits-row">
                    <div></div>
                    <div>
                        <h3>24/7 Online Support</h3>
                        <p>We have a team of support staff that are ready to give you timely assistance.</p>
                    </div>
                </div>

                <div className="benefits-row">
                    <div></div>
                    <div>
                        <h3>Safe Package</h3>
                        <p>We give attention to the fragility of the goods we are delivering. We exercise duly diligent for safe delivery.</p>
                    </div>
                </div>   
            </div>

            <div className="col-sm-6 benefits-column2">
                <div className="row form-container">
                    <div className="col-sm-6">
                        <img src={Lady} alt='3keys logistics Ltd' height='100%' />
                    </div>

                    <div className="col-sm-6">
                        <form className="frm">
                            <h3>Quick Quote</h3><br /><br />
                            <input className="inp form-control" type="text" id="fn" name="fn" placeholder="Fullname" /><br />                
                            <input className="inp form-control" type="text" id="eml" name="eml" placeholder="Email" /><br />
                            <input className="inp form-control" type="text" id="ph" name="ph" placeholder="Phone" /><br />
                            <input type="text" id="frt" className="form-control" name="frt" placeholder="Freight" /><br />
                            <input type="text" id="ld" className="form-control" name="ld" placeholder="Load" /><br />
                            <textarea type="text" className="form-control" id="msg" name="msg" rows="5">Message</textarea><br />
                            <input className="inp form-control btn btn-danger" type="submit" id="submit" name="submit" value="Send Request" />
                        </form>
                    </div>
                
                </div>
            </div>
            
        </div>
    );
}